module.exports = __webpack_public_path__ + "img/fig02.da885147.jpg";